import * as React from "react";

import { useProductListState } from "../providers";

import { MobileAppliedFilters } from "../mobile-applied-filters";

export const AppliedFilters: React.FunctionComponent = () => {
  const { selectedOptions } = useProductListState();

  if (selectedOptions.length < 1) {
    return null;
  }
  return (
    <div aria-label="applied filters" className="applied-filters">
      <p className="title">Applied Filters:</p>
      <MobileAppliedFilters />
    </div>
  );
};
